
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faClose, faInfo } from "@fortawesome/free-solid-svg-icons";
import Button from '@mui/material/Button';
import Spinner from 'react-bootstrap/Spinner';

import "./resend-link.scss";
import { useState } from "react";

interface ConfirmProps {
    show: boolean;
    onClose: (value: boolean) => void;
    onSubmit: () => void;
}

const ResendLinkModal: React.FC<ConfirmProps> = ({ show, onClose, onSubmit }) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        onClose(false);
    }

    const handleSubmit = () => {
        setIsLoading(true);
        onSubmit();
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="confirm-resend-modal">
            <Modal.Body className='resend-modal-wrapper'>
                <FontAwesomeIcon icon={faClose} className="modal-icon-close" onClick={handleClose}></FontAwesomeIcon>

                <div className="mb-2">
                    {
                        <FontAwesomeIcon icon={faCircleExclamation}></FontAwesomeIcon>
                    }
                </div>

                <p className="confirm-modal-title">
                    ลิงก์ตั้งค่ารหัสผ่านใหม่หมดอายุ
                </p>

                <p className="confirm-modal-description">
                    กดปุ่ม "ส่งลิงก์อีกครั้ง" เพื่อส่งลิงก์ตั้งค่ารหัสใหม่
                </p>
                <Button
                    variant="contained"
                    className="resend-modal-button"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    ส่งลิงก์อีกครั้ง

                    {
                        isLoading &&
                        <Spinner animation="border" role="status" className="resend-modal-button-loading">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                </Button>
            </Modal.Body>
        </Modal>
    )
}

export default ResendLinkModal;